import { call, put, take } from 'redux-saga/effects';

import { menusSlice } from '»components/Menus';
import { handleSagaError } from '»utils/handleSagasError';
import { navigate } from '»utils/navigation';

import { generalConditionsServices } from './generalConditions.services';
import { generalConditionsSlice } from './generalConditions.slice';

const setGeneralConditionsWorker = function* ({ documentId, documentVersion }) {
  try {
    yield call(generalConditionsServices.setGeneralConditions, {
      documentId,
      documentVersion,
    });

    yield put(generalConditionsSlice.actions.setGeneralConditionsSuccess());

    navigate('/Dashboard');
    yield put(
      menusSlice.actions.setActiveMenuItem({ activeMenuItem: 'DASHBOARD' }),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(generalConditionsSlice.actions.setGeneralConditionsFailure());
  }
};

const generalConditionsSagas = function* () {
  while (true) {
    const authorized = false;
    try {
      while (!authorized) {
        const data = yield take(
          generalConditionsSlice.actions.setGeneralConditionsRequest.type,
        );

        const { documentId, documentVersion } = data.payload;

        yield call(setGeneralConditionsWorker, { documentId, documentVersion });
      }
    } catch {
      yield put(generalConditionsSlice.actions.setGeneralConditionsFailure());
    }
  }
};

export { generalConditionsSagas };
